import { IFundingGenericValue } from 'src/components/Submission/GenericFieldComponents/FundingGeneric/FundingGenericForm';
import { ISubmissionFormData } from 'src/contexts/FormContext';

export function hasDuplicateFundingBody(
  data: ISubmissionFormData | IFundingGenericValue
): number {
  const FundingData = data?.metadata?.fundingGeneric?.value;
  if (!FundingData) return -1;

  const seen = new Set<string>();

  for (let i = 0; i < FundingData?.length; i++) {
    const fb = FundingData[i]?.fundingBody;
    if (!fb) continue;

    const normalized = fb?.trim()?.toLowerCase();

    if (seen.has(normalized)) return i; //  return index
    seen.add(normalized);
  }

  return -1; //  no duplicate found
}
